import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/admin.css'; // Import the CSS
import { DataContext } from '../sub-components/DataContext';
import AdminMenu from './adminMenu';
const AUTO_LOGOUT_TIME = 15 * 60 * 1000; // 15 minutes

const AdminPage = ({ setIsAuthenticated }) => {
    const { updateFaceBookEventsDB } = useContext(DataContext);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);

    const navigate = useNavigate();

    // Shared logout function
    const logout = () => {
        // Clear auth storage
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('authToken'); // optional if you keep it
        sessionStorage.clear();

        // 🔑 THIS IS THE KEY FIX
        setIsAuthenticated(false);

        // Redirect
        window.location.replace('/LoginPage');
    };



    // Auto-logout effect
    useEffect(() => {
        let logoutTimer = setTimeout(logout, AUTO_LOGOUT_TIME);

        const resetTimer = () => {
            clearTimeout(logoutTimer);
            logoutTimer = setTimeout(logout, AUTO_LOGOUT_TIME);
        };

        // Listen to user activity
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
        window.addEventListener('click', resetTimer);

        return () => {
            clearTimeout(logoutTimer);
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
            window.removeEventListener('click', resetTimer);
        };
    }, [navigate]);

    const handleUpdateEvents = async () => {
        setLoading(true);
        setSuccess(null);
        try {
            await updateFaceBookEventsDB();
            setSuccess(true);
        } catch (err) {
            console.error(err);
            setSuccess(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-container">
            <AdminMenu />

            <div className="admin-content">
                <h2>Welcome to the Admin Dashboard</h2>
                <p>Select an action from the menu on the left.</p>
                <p>Tod, use this tool!!</p>

                <div className="facebook-events-update">
                    <h3>Facebook Events</h3>
                    <button onClick={handleUpdateEvents} disabled={loading}>
                        {loading ? 'Updating...' : 'Update Facebook Events on DYS'}
                    </button>
                    {success === true && (
                        <p style={{ color: 'green' }}>Events updated successfully!</p>
                    )}
                    {success === false && (
                        <p style={{ color: 'red' }}>Error updating events. Check console.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminPage;
